module.exports = __webpack_public_path__ + "static/media/25.2d90cc9d.jpeg";